import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'primereact/dropdown'
import FormField from '../FormField'
import { resolveFieldError } from '../../../lib/forms/messages'

/**
 * RHF-bağlı açılır liste (020). `Controller` + PrimeReact `Dropdown` + `FormField`. Değer/hata RHF'den.
 */
export interface DropdownOption {
  label: string
  value: number | string
  /** Seçili gösterilir ama yeniden seçilemez (PrimeReact `option.disabled`). */
  disabled?: boolean
}

interface FormDropdownFieldProps<T extends FieldValues> {
  control: Control<T>
  name: FieldPath<T>
  label: string
  options: DropdownOption[]
  required?: boolean
  full?: boolean
  placeholder?: string
  panelClassName?: string
  /** Panelde arama kutusu (liste içinde arama — ör. toplantı grubu seçimi). */
  filter?: boolean
}

export default function FormDropdownField<T extends FieldValues>({
  control,
  name,
  label,
  options,
  required,
  full,
  placeholder,
  panelClassName,
  filter,
}: Readonly<FormDropdownFieldProps<T>>) {
  const { t } = useTranslation()
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormField
          label={label}
          htmlFor={name}
          required={required}
          full={full}
          error={resolveFieldError(fieldState.error?.message, t)}
        >
          <Dropdown
            inputId={name}
            value={field.value ?? null}
            options={options}
            onChange={(e) => field.onChange(e.value)}
            onBlur={field.onBlur}
            placeholder={placeholder}
            panelClassName={panelClassName}
            filter={filter}
            // Panel açılınca varsayılan ~200px (≈5 kayıt) yerine ~10 kayıt görünsün (029 talebi).
            scrollHeight="400px"
            className={fieldState.error ? 'p-invalid' : undefined}
          />
        </FormField>
      )}
    />
  )
}
